<template>
  <div class="_seafreighttracking global__scrollcustom">
    <div class="row m-0 h-100">
      <div class="w-100">
        <h5>TRUCK LIVE GPS TRACKING</h5>
        <template v-if="idTracking">
          <p>Click the button bellow to locate your shipment by using Andalin Truck Live GPS Tracking</p>
          <router-link :to="{ name: 'LandShipmentTracking', params: { idTracking} }" class="d-block mt-4" target="_blank">
              <button class="button__deepgreen px-4">
                  Track Here
              </button>        
          </router-link>
        </template>
        <template v-else>
          <p>Please wait we are currently preparing your shipment tracking link.</p> 
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LandFreightTracking',
  props: {
    idTracking: {
      type: String,
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/managementShipment/detail/LandFreightTracking.vue